/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import Vue from 'vue';
import Vuex, { createLogger } from 'vuex';

Vue.use(Vuex);

// Plugin Vuex Persistance
import { createVuexPersistance } from './vuex-persistance-plugin';

// Global
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// Module
import context from './context/moduleContext';
// Init instance of store
const store = new Vuex.Store({
	// plugins:
	// 	process.env.NODE_ENV !== 'production'
	// 		? [createLogger(), createVuexPersistance()]
	// 		: [createVuexPersistance()],
	getters,
	mutations,
	state,
	actions,
	modules: {
		context,
	},	
	strict: false
});

export default store;
